import { InvoiceHistoryActionType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/values/values.pb';
import { InvoiceHistory } from '@weave/schema-gen-ts/dist/schemas/payments/views/service/service.pb';
import { useTranslation } from '@frontend/i18n';
import { IconName } from '@frontend/icons';
import { paymentTypeMap } from '@frontend/payments-hooks';
import { formatPhoneNumber } from '@frontend/phone-numbers';

type ActionDetails = {
  icon: IconName;
  title: string;
};

export const useGetRequestActivityMap = (action: InvoiceHistory): ActionDetails => {
  const { t } = useTranslation('payments');

  const requestActivity = () => {
    switch (action.actionType) {
      case InvoiceHistoryActionType.ACTION_CREATED:
        return {
          icon: 'plus' as IconName,
          title: t('Payment Request created'),
        };
      case InvoiceHistoryActionType.ACTION_PAYMENT_SUCCESSFUL:
        return {
          icon: 'payments' as IconName,
          title: `${action.origin ? paymentTypeMap[action?.origin] : 'Unknown'} ${t('Payment Taken')}`,
        };
      case InvoiceHistoryActionType.ACTION_PAYMENT_RECEIPT_EMAIL_SENT:
        return {
          icon: 'payments' as IconName,
          title: action.receiptSentToEmail
            ? t(`Payment Receipt Email Sent to ${action.receiptSentToEmail}`)
            : t('Payment Receipt Email Sent'),
        };
      case InvoiceHistoryActionType.ACTION_PAYMENT_FAILED:
        return {
          icon: 'pay' as IconName,
          title: `${action.origin ? paymentTypeMap[action?.origin] : 'Unknown'} ${t('Payment Failed')}`,
        };
      case InvoiceHistoryActionType.ACTION_REFUND:
        return {
          icon: 'refund' as IconName,
          title: t('Payment Refunded'),
        };
      case InvoiceHistoryActionType.ACTION_PARTIAL_REFUND:
        return {
          icon: 'refund' as IconName,
          title: t('Payment Partially Refunded'),
        };
      case InvoiceHistoryActionType.ACTION_REFUND_RECEIPT_EMAIL_SENT:
        return {
          icon: 'payments' as IconName,
          title: action.receiptSentToEmail
            ? t(`Refund Receipt Email Sent to ${action.receiptSentToEmail}`)
            : t('Refund Receipt Email Sent'),
        };
      case InvoiceHistoryActionType.ACTION_REMINDER:
        return {
          icon: 'messaging' as IconName,
          title: `${t('Payment Link sent to ')} ${formatPhoneNumber(action.phoneNumber)}`,
        };
      case InvoiceHistoryActionType.ACTION_CANCELLATION:
        return {
          icon: 'remove' as IconName,
          title: t('Payment Cancelled'),
        };
      case InvoiceHistoryActionType.ACTION_UPDATED:
        return {
          icon: 'update' as IconName,
          title: t('Payment Updated'),
        };
      case InvoiceHistoryActionType.ACTION_PROCESSING:
        return {
          icon: 'pending' as IconName,
          title: t('Payment Pending'),
        };
      case InvoiceHistoryActionType.UNKNOWN_ACTION_TYPE:
        return {
          icon: 'payments-receipt' as IconName,
          title: t('Unknown activity'),
        };

      default:
        return {
          icon: 'payments-receipt' as IconName,
          title: t('Unknown activity'),
        };
    }
  };

  return requestActivity();
};
